<sn-icon
  *ngIf="icon"
  [icon]="icon.icon"
  [fontSet]="icon.fontSet"
  [fontIcon]="icon.fontIcon"
  [fontIconUnicode]="icon.fontIconUnicode"
  [svgIcon]="icon.svgIcon"
  [snBadge]="badge?.value"
  [snBadgeSize]="badge?.size"
  [snBadgeColor]="badge?.color"
  [snBadgePositionX]="badge?.positionX"
  [size]="icon.size"
  [snBadgePositionY]="badge?.positionY"
>
</sn-icon>
<div
  *ngIf="iconLabel?.text"
  class="icon-label"
  [style.top]="iconLabel.top.toString() + 'px'"
  [style.left]="iconLabel.left.toString() + 'px'"
  [style.fontSize]="iconLabel.fontSize"
  [style.color]="iconLabel.color"
  [style.]="iconLabel.transform"
>
  {{ iconLabel.text }}
</div>
